import React from 'react';

export interface AdminDisables{
    app: boolean;
    seckey: boolean;
    timeout: boolean;
    connect: boolean;
    disconnect: boolean;
    switch: boolean;
    loginlog: boolean;
    others: boolean;
}

export const beforeConnectingForAdmin: AdminDisables = {
    app: false,
    seckey: false,
    timeout: false,
    connect: false,
    disconnect: true,
    switch: false,
    loginlog: false,
    others: true
}

export const onClickForAdmin: AdminDisables = {
    app: true,
    seckey: true,
    timeout: true,
    connect: true,
    disconnect: false,
    switch: true,
    loginlog: false,
    others: true
}

export const connectingForAdmin: AdminDisables = {
    app: true,
    seckey: true,
    timeout: true,
    connect: true,
    disconnect: false,
    switch: true,
    loginlog: true,
    others: false
}

export const disconnectingForAdmin: AdminDisables = {
    app: true,
    seckey: true,
    timeout: true,
    connect: false,
    disconnect: true,
    switch: false,
    loginlog: false,
    others: false
}

export const DisabelesAdminContext = React.createContext(beforeConnectingForAdmin);
export const SetDisablesAdminContext = React.createContext<React.Dispatch<React.SetStateAction<AdminDisables>>>(() => {});
